import IserbaModal from "components/shared/iserba/IserbaModal";
import React, { useRef } from "react";

const GameEndScreen = ({
	title,
	score,
	text,
	levelCompleted,
	collectedItems,
	onNextLevel,
	onReplay,
}) => {
	const scoreRef = useRef();

	return (
		<>
			<IserbaModal isOpen={true}>
				<div className="flex flex-col items-center justify-center">
					<h1 className="text-gray-600 text-3xl font-bold text-center font-orbitron mb-2">
						{title}
					</h1>

					<div className="flex gap-2 items-center justify-center font-orbitron text-xl font-bold text-gray-600 mb-2">
						Score :
						<span ref={scoreRef} className="text-[#fbb554]">
							{score}
						</span>
					</div>

					{text && (
						<p className="text-gray-600 text-xl text-center mt-4 mb-2 font-bold">
							{text}
						</p>
					)}

					{levelCompleted ? (
						<button
							onClick={onNextLevel}
							className="mt-8 rounded-full px-4 py-2 border-black text-white bg-[#fbb554] shadow-[6px_6px_0px_rgba(0,0,0,0.7)] hover:bg-[#ffa256] disabled:bg-slate-300"
						>
							Niveau suivant
						</button>
					) : (
						<button
							onClick={onReplay}
							className="mt-2 rounded-full px-4 py-2 border-black text-white bg-[#fbb554] shadow-[6px_6px_0px_rgba(0,0,0,0.7)] hover:bg-[#ffa256] disabled:bg-slate-300"
						>
							Rejouer
						</button>
					)}
				</div>
			</IserbaModal>
		</>
	);
};

export default GameEndScreen;
